import React from 'react';
import PageWrapper from '../../components/PageWrapper';
import { Link } from 'react-router-dom';
import { RiArrowLeftSLine } from 'react-icons/ri';
import SupplierForm from './components/SupplierForm';

const CreateSupplier = () => {
  return (
    <PageWrapper>
      <div className="bg-gray-25 px-8 py-6 flex items-start gap-3 border-b sticky top-[8.2%]  z-[100] bg-white">
        <Link to="/suppliers">
          <RiArrowLeftSLine size={24} className="text-gray-900" />
        </Link>
        <div className="space-y-1">
          <h1 className="text-text-lg font-bold text-[#000000]">
            Create New Supplier
          </h1>
          <p className="text-gray-600 text-xs font-[400]">
            Enter the details of the new supplier below to add them to your
            list.
          </p>
        </div>
      </div>
      <div className="relative">
        <SupplierForm />
      </div>
    </PageWrapper>
  );
};

export default CreateSupplier;
